<script setup lang="ts">
import { inject }               from "vue";
import type { TypeCommonProps } from "@ViewPages/Main/Components/commonTypes";
import HeaderBodyForm           from "@ViewPages/Main/Components/Header/HeaderBodyForm.vue";

const props = inject<TypeCommonProps>('header_props')
</script>

<template>
    <div class="header__body flex flex-col md:flex-row overflow-hidden">
        <div class="header__body-left xl:w-1/2 xl:shrink-0 max-md:order-2">
            <h1 class="text-5xl xl:text-6xl mb-6 font-bold xl:mb-11"
                v-html="__('header_title')"></h1>

            <div class="text-xl font-medium mb-10 xl:mb-14">
                {{ __('header_description') }}
            </div>

            <div class="header__form-inner">
                <div class="header__form-title text-3xl xl:text-4.63xl
                            font-bold mb-5 xl:gap-y-7 xl:gap-x-6"
                     v-html="__('header_form_tile')">
                </div>

                <HeaderBodyForm></HeaderBodyForm>
            </div>
        </div>

        <div class="header__body-right relative max-md:order-1 -mx-11"
             v-html="props?.containers_img_tag">
        </div>
    </div>
</template>

<style scoped>

</style>
